import React from 'react';

const formatReceiptMoney = (value) =>
  parseFloat(value || 0).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const formatReceiptQty = (value) =>
  Number(value || 0).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const formatReceiptDate = (salesDate) => {
  if (!salesDate) return '';
  const d = new Date(`${String(salesDate).slice(0, 10)}T00:00:00`);
  if (Number.isNaN(d.getTime())) return String(salesDate);
  return d.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
};

const SalesReceiptPrint = React.forwardRef(function SalesReceiptPrint(
  { header = {}, items = [], paymentMode = 'Cash' },
  ref
) {
  const subtotal = (items || []).reduce(
    (sum, item) => sum + Number(item.line_total || 0),
    0
  );
  const adjustments = Number(header.sales_adjustments || 0);
  const total =
    header.sales_total != null && header.sales_total !== ''
      ? Number(header.sales_total)
      : subtotal + adjustments;

  return (
    <div ref={ref} className="sales-receipt-print">
      <div className="sr-top">
        <div className="sr-org">
          <div className="sr-org-name">Shuman Hospital</div>
          <div>Freetown</div>
          <div>Sierra Leone</div>
          <div>billing@shumanhospital.com</div>
        </div>
        <div className="sr-meta">
          <div className="sr-title">SALES RECEIPT</div>
          <div className="sr-meta-row">
            <span className="sr-label">Sales Receipt#</span>
            <span>{header.sales_number || ''}</span>
          </div>
          <div className="sr-meta-row">
            <span className="sr-label">Date</span>
            <span>{formatReceiptDate(header.sales_date)}</span>
          </div>
          <div className="sr-meta-row">
            <span className="sr-label">Payment Mode</span>
            <span>{paymentMode}</span>
          </div>
        </div>
      </div>

      <div className="sr-patient">
        <div className="sr-patient-row">
          <span className="sr-label">Patient Name</span>
          <span>{header.patient_name || ''}</span>
        </div>
        <div className="sr-patient-row">
          <span className="sr-label">Patient ID</span>
          <span>{header.patient_id || ''}</span>
        </div>
      </div>

      <table className="sr-items">
        <thead>
          <tr>
            <th className="sr-col-num">#</th>
            <th className="sr-col-item">Item</th>
            <th className="sr-col-qty">Qty</th>
            <th className="sr-col-rate">Rate</th>
            <th className="sr-col-amt">Amount</th>
          </tr>
        </thead>
        <tbody>
          {(items || []).map((item, index) => (
            <tr key={item.sales_record_id || `sr-line-${index}`}>
              <td className="sr-col-num">{index + 1}</td>
              <td className="sr-col-item">{item.line_description || ''}</td>
              <td className="sr-col-qty">
                <div>{formatReceiptQty(item.quantity ?? 1)}</div>
                <div className="sr-unit">Pcs</div>
              </td>
              <td className="sr-col-rate">{formatReceiptMoney(item.rate)}</td>
              <td className="sr-col-amt">{formatReceiptMoney(item.line_total)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="sr-totals">
        <div className="sr-total-row">
          <span>Sub Total</span>
          <span>{formatReceiptMoney(subtotal)}</span>
        </div>
        {adjustments !== 0 && (
          <div className="sr-total-row">
            <span>Adjustment</span>
            <span>{formatReceiptMoney(adjustments)}</span>
          </div>
        )}
        <div className="sr-total-row sr-grand">
          <span>TOTAL</span>
          <span>SLL{formatReceiptMoney(total)}</span>
        </div>
      </div>
    </div>
  );
});

export default SalesReceiptPrint;
